import React from 'react';
import { Box, Heading } from '@wix/design-system';

export const TitleAndSubTitle: React.FC<{
  title: string;
  subtitle: string;
}> = ({ title, subtitle }) => {
  return (
    <Box
      margin="0 auto SP6"
      direction="vertical"
      maxWidth="820px"
      align="center"
      textAlign="center"
    >
      <Heading dataHook="app-title" appearance="H1">
        {title}
      </Heading>
      <Heading dataHook="app-subtitle" appearance="H4">
        {subtitle}
      </Heading>
    </Box>
  );
};
